import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Badge, Button } from '@mui/material';
import { Update } from '@mui/icons-material';
import { useAction } from 'shared/hooks/redux/hooks';
import { useHasFirmwareUpdate } from 'entities/device.service.upgrades/model/check-firmware';
import { open_upgrade_dialog } from 'console/device-settings/upgrade-dialog/redux/action';
import { ErrorBoundary } from 'shared/components/error-boundary';
export const UpdateButton = memo(function UpdateButtonImpl(props) {
    const { device_id, title, ...rest } = props;
    const has_updates = useHasFirmwareUpdate(device_id);
    const onOpenUpgradeDialog = useAction(open_upgrade_dialog);
    return (_jsx(ErrorBoundary, { children: _jsx(Badge, { badgeContent: has_updates ? 1 : 0, color: "error", children: _jsx(Button, { onClick: onOpenUpgradeDialog, variant: "outlined", color: "primary", startIcon: _jsx(Update, {}), size: "small", ...rest, children: title != null ? title : 'Обновить' }) }) }));
});
